const balanceCardGrid = (grid) => {
    const cards = Array.from(grid.querySelectorAll('.card'));
    const cols = Number(getComputedStyle(grid).getPropertyValue('--cols'));
    const rowCount = Math.ceil(cards.length / cols);

    cards.forEach((card) => {
        card.style.removeProperty('--span');
    });

    if (!cols || !rowCount) {
        return;
    }

    const baseRowSize = Math.floor(cards.length / rowCount);
    const rowsWithExtraCard = cards.length % rowCount;
    let cardIndex = 0;

    for (let rowIndex = 0; rowIndex < rowCount; rowIndex += 1) {
        const rowSize = baseRowSize + (rowIndex < rowsWithExtraCard ? 1 : 0);
        const span = 60 / rowSize;

        for (let itemIndex = 0; itemIndex < rowSize; itemIndex += 1) {
            cards[cardIndex].style.setProperty('--span', span);
            cardIndex += 1;
        }
    }
};

const queueCardBlockBalance = () => {
    window.requestAnimationFrame(() => {
        document.querySelectorAll('.cards-grid').forEach(balanceCardGrid);
    });
};

$('.js-card-blocks-slider').each(function () {
    var cardSlider = $(this);

    function toggleCardSlider() {
        if (window.innerWidth < 576) {
            if (!cardSlider.hasClass('slick-initialized')) {
                cardSlider.slick({
                    arrows: false,
                    dots: false,
                    infinite: false,
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    accessibility: true,
                    regionLabel: 'Card blocks slider'
                });
            }

            queueCardBlockBalance();
            return;
        }

        if (cardSlider.hasClass('slick-initialized')) {
            cardSlider.slick('unslick');
        }

        queueCardBlockBalance();
    }

    toggleCardSlider();

    $(window).on('resize', function () {
        toggleCardSlider();
    });
});

window.addEventListener('load', queueCardBlockBalance);
window.addEventListener('resize', queueCardBlockBalance);

